<template>
<div>
  <div v-if="materials.length" class="material-list">
    <div id="material-list-wrapper" class="material-list__wrapper">
      <flickity class="flickity carousel" ref="flickity" @init="onInit" :options="flickityOptions">
        <MaterialCard v-for="material in filteredMaterials" :key="material.id" :material="material" />
      </flickity>
    </div>
    <SlideDown />
    <div class="materials__register-info-wrapper">
      <img class="materials__icon" src="@/assets/images/materials-light.svg" />
      <div class="materials__register-info-inner-wrapper">
        <h2
          class="materials__register-info"
          v-html="$t('materials.music_app_info_heading')"
        ></h2>
        <span class="materials__link-prefix"
          >{{ $t("materials.music_app_info_cta") }}
          <a
            id="materials-instruction"
            href="https://docs.google.com/presentation/d/1v_uuKMyZ_b-GMgr__km3xF83phtF5Jw8wmR49HV7cIs/edit?usp=sharing"
            target="_blank"
            class="materials__link"
            >{{ $t("materials.music_app_info_link_label") }}</a
          ></span
        >
      </div>
    </div>
  </div>
  <div v-else class="materials__empty-list">
    <span class="materials__empty-list-label">{{ $t("materials.empty_list_part1") }} <span @click="logoutUser"  :class="{ 'inactive':  logoutInProgress }" class="materials__log-out">{{ $t("materials.log_out") }}</span>{{ $t("materials.empty_list_part2") }}</span>
  </div>
  </div>
</template>

<script>
import MaterialCard from '@/components/MaterialList/MaterialCard.vue';
import SlideDown from '@/components/SlideDown.vue';

export default {
  name: 'MaterialList',
  props: {
    materials: Array,
  },
  data() {
    return {
      logoutInProgress: false,
      flickityOptions: {
        cellAlign: 'left',
        groupCells: true,
        pageDots: false,
        watchCSS: true,
        arrowShape: 'M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z',
      },
    };
  },
  computed: {
    filteredMaterials() {
      return this.materials.filter(material => !!material.webUrl || !!material.androidUrl || !!material.iosUrl);
    },
  },
  methods: {
    async logoutUser() {
      this.logoutInProgress = true;
      try {
        await this.$store.dispatch('auth/logout');
      } catch (e) {
        console.error(e);
      } finally {
        this.logoutInProgress = false;
      }
    },
    setHeight() {
      const bars = [...document.querySelectorAll('.material-card-bottom-info')];
      const barsSize = bars.map((bar) => {
        const height = bar.getBoundingClientRect();
        return height.height;
      });

      let largest = 0;

      for (let i = 0; i <= largest; i += 1) {
        if (barsSize[i] > largest) {
          largest = barsSize[i];
        }
      }
      bars.forEach((bar) => {
        // eslint-disable-next-line no-param-reassign
        bar.style.height = `${largest}px`;
        return false;
      });
    },
    onInit() {
      this.$refs.flickity.on('change', () => {
        if (this.$gtm.enabled()) {
          this.$gtag.event('Przesuwanie listy materiałów online', {
            event_value: 'Przesuwanie listy materiałów online',
          });
        }
      });
    },
  },
  components: {
    MaterialCard,
    SlideDown,
  },
};
</script>

<style lang="scss">

.inactive {
  @apply pointer-events-none;
}

.material-list{
  .flickity-button {
    background: transparent;
  }
  .flickity-prev-next-button {
    width: 70px;
    height: 40px;
    border-radius: 0;
    transition: 0.3s;
    z-index: 10;
    svg{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      transition: 0.3s;
      path{
        transform: scale(5);
      }
    }
  }
  .flickity-prev-next-button.previous{
      svg{
      path{
        transform:  scale(5) rotate(180deg) translate(-22%, -22px)
      }
    }
  }

  .flickity-prev-next-button.previous{
    left: -57px;
    &:hover {
      svg{
        left: calc(50% - 15px);
      }
    }
  }

  .flickity-prev-next-button.next{
    right: -52px;
    &:hover{
      svg{
        left: calc(50% + 15px);
      }
    }

  }
  .flickity-button:disabled {
    opacity: 0;
  }
  .flickity-button:hover {
    background: transparent;
  }
}
</style>

<style lang="scss" scoped>
.carousel {
  @media screen and (max-width: 991px) {
    display: grid;
    grid-template-columns: 335px;
    justify-content: center;
    grid-auto-rows: 1fr;
    grid-gap: 20px;
  }
  @media screen and (max-width: 420px) {
    grid-template-columns: 100%;
    justify-content: center;
  }
  &:after {
    content: "flickity";
    display: none;
    @media screen and (max-width: 991px) {
      content: "";
    }
  }
}
.material-list {
  position: relative;
  max-width: 1020px;
  animation: fadeIn 0.2s cubic-bezier(0.56, 0.33, 0.54, 0.95) 0.3s both;
  @media screen and (min-width: 992px) {
    margin: 0 78px 0 40px;
  }
  &__wrapper {
    width: 100%;
  }
}
</style>
